import clsx from 'clsx';
import React from 'react';

import Icon, { ICONS, ICON_TYPES } from '@/src/components/common/Elements/Icon/Icon';

const AutomationProcessingButton = () => {
  return (
    <React.Fragment>
      <div
        className={clsx(
          'tw-group',
          'tw-flex tw-items-center',
          'tw-ml-[10px] tw-px-[10px] tw-py-[4px]',
          'tw-rounded-[5px]',
          'tw-text-cfo-black tw-bg-[rgba(151,71,255,0.1)] tw-border-[rgba(151,71,255,0.1)]'
        )}
      >
        <Icon
          icon={ICONS.loaderSpinner({ mainColor: '#9747FF', secondaryColor: '#FED4FF' })}
          iconType={ICON_TYPES.rounded}
          className={clsx('tw-text-[15px] tw-mr-[5px]', 'tw-animate-spin-slow')}
        />
        {/* <div className=" tw-ease-linear tw-rounded-full tw-border-t-4 tw-border-l-4 tw-border-[transparent transparent white white] tw-h-12 tw-w-12 tw-animate-spin"></div> */}
        Processing...
      </div>
    </React.Fragment>
  );
};

export default AutomationProcessingButton;
